import { TextUtilsService, TextToImageConfig } from '../../textUtils.service';

declare let THREE: any;

export class Label extends (THREE.Mesh as { new(geometry, material): any; }) {

  private static rotationTransform = new THREE.Matrix4().makeRotationX(THREE.Math.degToRad(-90));
  static readonly Name = 'Label';
  protected textConfig: TextToImageConfig;
  private width;
  private height;
  public scaleCor; 

  constructor(size: { width: number, height: number }, textConfig?: TextToImageConfig) {
    const geometry = new THREE.PlaneBufferGeometry(1, 1).applyMatrix(Label.rotationTransform);
    const material = new THREE.MeshBasicMaterial({ side: THREE.FrontSide, depthTest: false, transparent: true });
    super(geometry, material);
    this.name = Label.Name;
    this.textConfig = textConfig;
    this.width = size.width;
    this.height = size.height;
    this.scaleCor = 1;
    this.scale.set(size.width + 10, 1, size.height + 10);
  }

  onBeforeRender(renderer, scene, camera) {
    const scale = camera.scale.x;
    this.scale.set(this.width * this.scaleCor, 1, this.height * this.scaleCor);  
  }

  updateText(text: string) {
    const image = TextUtilsService.textToImage(text, this.textConfig, true);
    if (!this.material.map) {
      this.material.map = new THREE.Texture(image);
    } else {
      this.material.map.image = image;
    }
    this.material.map.needsUpdate = true;
    this.material.needsUpdate = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Label.ts